import { render, staticRenderFns } from "./_calender_detail.vue?vue&type=template&id=52ad7db9&"
import script from "./_calender_detail.vue?vue&type=script&lang=js&"
export * from "./_calender_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports